/**
 * @packageDocumentation
 * @module f1/is
 */

import { t_falsy } from '../types';

export interface IsTruthy {
  /**
   * Is truthy, which is not falsy
   *
   * @public
   * @see f1.is.falsy
   * @function f1.is.truthy
   * @example
   *
   * ```ts
   * f1.is.truthy(1) => true
   * f1.is.truthy(true) => true
   * f1.is.truthy([]) => true
   *
   * f1.is.truthy(false) => false
   * f1.is.truthy(0) => false
   * f1.is.truthy('') => false
   * ```
   */
  <V>(value: V | t_falsy): value is V;
}

/**
 * @see IsTruthy
 */
export default <V>(value: V | t_falsy): value is V => {
  return !!value;
};
